import React from 'react'
import "./Creatlinks.scss"
import { FaYoutube, FaFacebookF, FaWhatsapp, FaInstagram, FaTelegramPlane } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoMdCopy } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { SiYoutubeshorts } from "react-icons/si";

export default function Creatlinks() {
  // المنصات
  const platforms = [
    { name: 'YouTube', icon: <FaYoutube className='platform-icon' style={{ color: 'red' }} /> },
    { name: 'Facebook', icon: <FaFacebookF className='platform-icon' style={{ color: '#3b5998' }} /> },
    { name: 'Shorts', icon: <SiYoutubeshorts className='platform-icon' style={{ color: 'red' }} /> },
    { name: 'WhatsApp', icon: <FaWhatsapp className='platform-icon' style={{ color: '#25D366' }} /> },
    { name: 'Instagram', icon: <FaInstagram className='platform-icon' style={{ color: '#E1306C' }} /> },
    { name: 'Telegram', icon: <FaTelegramPlane className='platform-icon' style={{ color: '#229ED9' }} /> },
  ];

  return (
    <div className='create-links-container p-3'>
      <h4 className='address'>Create Marketing Links</h4>

      {platforms.map((platform, index) => (
     <div key={index} className='link-row  d-flex align-items-center '>
 <div className='d-flex align-items-center'>
  <div className='platform d-flex align-items-center' style={{ minWidth: '150px', gap: '10px' }}>
    {platform.icon}
    <span>{platform.name}</span>
  </div>


   <div className='d-flex align-items-center gap-3'>
              <input type="text" className='link-input' placeholder={`Type your ${platform.name} link`} />
              <button className='crt-btn'>Create</button>
            </div>

 </div>


  <div className='icon-actions d-flex align-items-center' style={{  justifyContent: 'flex-end' }}>
    <RiDeleteBinLine className='action-icon' />
    <IoMdCopy className='action-icon' />
    <IoIosArrowDown className='action-icon' />
  </div>
</div>

      ))}
    </div>
  )
}
